import './calendar-select-modal.style.sass';
import template from './calendar-select-modal.tpl.pug';

class CalendarSelectModalController {
    select(calendar) {
        this.onClose({
            data: calendar
        });
    }

    dismiss() {
        this.onDismiss();
    }
}

export default {
    selector: 'dbACalendarSelectModal',
    template: template(),
    controller: CalendarSelectModalController,
    bindings: {
        calendars: '<',
        selected: '<',
        title: '<',

        onClose: '&',
        onDismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/calendar-select-modal/calendar-select-modal.cmpt.js